module.exports = __webpack_public_path__ + "aa22c91d0d4a5307895870a4bd228533.jpg";